export enum SetPasswordStep {
  Expired = 1,
  Set = 2,
  Success = 3,
  ConnectionError = 4,
}
